import { c as _c } from "react/compiler-runtime";
import { BusSolid, CalendarSolid, FerrySolid, MapPinSolid, OvernightBus, OvernightFerry, SleeperTrain, Taxi, TrainSolid } from '@byway/icons';
import { useTranslations } from 'next-intl';
import type { Key } from 'react';
import { Tag } from 'ui';
import { journeyItemTypeKeys } from '~/constants/journey-item-types';
import { transportClassKeys } from '~/constants/transport-classes';
import type { ChipHeaderProps } from './ChipHeader.types';
const ICON_COMPONENTS = {
  bus: BusSolid,
  calendar: CalendarSolid,
  ferry: FerrySolid,
  journey: TrainSolid,
  'map-pin': MapPinSolid,
  'overnight-bus': OvernightBus,
  'overnight-ferry': OvernightFerry,
  'sleeper-train': SleeperTrain,
  taxi: Taxi,
  train: TrainSolid
};
const ChipHeader = t0 => {
  const $ = _c(14);
  const {
    icons,
    tags,
    type
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== icons) {
    t1 = icons && icons.length > 0 && icons.map(_temp);
    $[0] = icons;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = journeyItemTypeKeys[type];
  let t3;
  if ($[2] !== t || $[3] !== t2.labelKey) {
    t3 = t(t2.labelKey);
    $[2] = t;
    $[3] = t2.labelKey;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <li><Tag mode="primary" label={t3} size="small" className="flex-[0_0_auto] border text-white bg-black border-black print:bg-transparent print:border-black print:text-black" /></li>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t || $[8] !== tags) {
    t5 = tags.map((tag, index_0) => {
      const lastTag = tags[tags.length - 1];
      const transportClassKey = Object.hasOwn(transportClassKeys, lastTag) ? transportClassKeys[lastTag] : null;
      const transportClass = transportClassKey ? t(transportClassKey.labelKey) : null;
      if (index_0 === tags.length - 1 && transportClass) {
        return <li key={`tag-${index_0}`} className="flex-[0_0_auto]"><Tag size="small" label={transportClass} className="border border-neutral-400 bg-neutral-200 print:border-black" /></li>;
      }
      return <li key={`tag-${index_0}`} className="flex-[0_0_auto]"><Tag size="small" label={tag.replace(/_/g, " ")} className="border border-neutral-400 print:border-black" /></li>;
    });
    $[7] = t;
    $[8] = tags;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <ul className="flex flex-wrap gap-1 items-center print:break-inside-avoid">{t1}{t4}{t5}</ul>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export { ChipHeader };
function _temp(icon, index) {
  const IconComponent = ICON_COMPONENTS[icon];
  return IconComponent ? <li key={index} className="flex p-1 items-center justify-center text-white bg-black rounded-full shrink-0 w-[1.75em] h-[1.75em] print:bg-transparent print:border print:border-black print:text-black"><IconComponent decorative={true} /></li> : null;
}